var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { iconButtonClasses, Popover } from "@mui/material";
import { createDraggableTransition } from "../../Utils";
import { truffleModalTitleDragHandleClassName } from "../TruffleModalTitle";
export const TrufflePopover = (_a) => {
    var { variant = "standard" } = _a, popoverProps = __rest(_a, ["variant"]);
    return (_jsx(Popover, Object.assign({ TransitionComponent: TransitionComponent, slotProps: { paper: { sx: PAPER_SX_BY_VARIANT[variant] } }, anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        } }, popoverProps)));
};
const PAPER_SX_BY_VARIANT = {
    standard: {
        paddingBlockStart: "8px",
        paddingBlockEnd: "16px",
        paddingInlineStart: "16px",
        paddingInlineEnd: "16px",
        minWidth: "260px"
    },
    pill: {
        paddingBlockStart: "4px",
        paddingBlockEnd: "4px",
        paddingInlineStart: "4px",
        paddingInlineEnd: "4px",
        borderRadius: "999px"
    }
};
const TransitionComponent = createDraggableTransition({
    draggableProps: {
        handle: `.${truffleModalTitleDragHandleClassName}`,
        bounds: "parent",
        cancel: `.${iconButtonClasses.root}`
    }
});
//# sourceMappingURL=TrufflePopover.js.map